import client from './api-client';

export const getConfiguracionForm33 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form33: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getModalesConsulta = async(query) => {
    try {
        
        const response = await client.get(`modales-consulta?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getAntecedentesCaso = async(query) => {
    try {
        
        const response = await client.get(`caso?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetApoderados = async (query) => {
    try {
        const response = await client.get(`proveedores-rol?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const servicesAsignarApoderado = async(data) => {
    
    try {
        
        const response = await client.post('caso/asigna-apoderado',data);
        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}